import type { SVGProps } from "react";

export function CryptoK( props: SVGProps<SVGSVGElement> ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M7.01514 4.10975L6.1012 7.48562L9.05508 8.28532C9.98729 8.53769 10.9476 7.98656 11.2 7.05436C11.4524 6.12215 10.9012 5.16182 9.96903 4.90945L9.12506 4.68096M7.01514 4.10975L5.32721 3.65278M7.01514 4.10975L7.47211 2.42182M7.01514 4.10975L9.12506 4.68096M9.12506 4.68096L9.58203 2.99303"
                stroke="#F8931A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.18708 10.8602L6.10102 7.48432L9.89887 8.5125C10.8311 8.76488 11.3822 9.7252 11.1298 10.6574C10.8775 11.5896 9.91713 12.1407 8.98493 11.8884L7.29699 11.4314M5.18708 10.8602L4.7301 12.5481M5.18708 10.8602L3.49914 10.4032L7.29699 11.4314M5.18708 10.8602L7.29699 11.4314M7.29699 11.4314L6.84002 13.1193"
                stroke="#F8931A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
